module.exports = __webpack_public_path__ + "static/media/nomination_email_example.33545eb4.png";